import React, { useState } from "react"
import Template from "../templates/template"
import styled from "styled-components"
import { theme, Container } from "../styles/theme"
import media from "../styles/media"

import banner from "../assets/images/img-principal-matriculacion.jpg"
import icon from "../assets/images/icon-matriculacion.svg"
import ModalMunicipio from "../components/ModalCondition"

const Content = styled.div`
  background: #202122;
  & .btn-impuestos {
    font-weight: 500;
    font-style: normal;
    letter-spacing: 1px;
    padding: 13px 20px;
    color: #202122;
    font-size: 20px;
    margin-top: 0;
    background: #999a9f;
    background: linear-gradient(
      135deg,
      #999a9f 0%,
      #999a9f 21%,
      #b0b0b3 21%,
      #b0b0b3 48%,
      #cbcacb 48%,
      #cbcacb 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );
    display: inline-block;
  }
`

const TableInfo = styled.table`
  width: 70%;
  margin: 10px auto 20px auto;
  text-align: center;

  th {
    text-align: center;
    padding: 10px;
  }

  & .cabecera {
    background-color: #0f6aac;
    color: ${theme.white};
  }

  ${media.sm`
    width: 100%;
    font-size: 12px;
  `};
`

const Buttons = styled.div`
  padding-bottom: 10px;
  div {
    text-align: center;
    display: block;
  }
  p {
    font-size: 20px !important;
  }
  .pay-here {
    width: 100%;
    ${media.xs`
      width: 100%;
  `};
  }
  a {
    display: inline-block;
  }
`

const title = "Paga tus impuestos en línea."
const Matriculacion = () => {
  const [isOpen, setIsOpen] = useState(false)

  function toggleModal() {
    setIsOpen(!isOpen)
  }

  return (
    <Template banner={banner} title={title} icon={icon} active="matriculacion">
      {({ handleModalShow }) => (
        <Content className="row">
          <div class="col-md-12">&nbsp;</div>
          <div className="col-lg-12">
            <div className="text-center">
              <a
                id="CORPIMP_MATRI_CONOZCA"
                className="btn-impuestos"
                onClick={toggleModal}
              >
                Conozca más sobre la clave temporal
              </a>
              <ModalMunicipio
                onAfterOpen={false}
                isOpen={isOpen}
                onRequestClose={toggleModal}
                ariaHideApp={false}
                contentLabel="ModalMunicipio"
              />
            </div>
          </div>
          <Container className="title">
            <div className="col-md-12">
              <p>Calendario de Pago</p>
            </div>
          </Container>
          <Container className="content">
            <div className="col-md-12">
              <TableInfo>
                <tbody>
                  <tr className="cabecera">
                    <td></td>
                    <td>Obligatorio</td>
                    <td>Opcional</td>
                  </tr>
                  <tr className="odd">
                    <td>ENERO</td>
                    <td></td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>FEBRERO</td>
                    <td>1</td>
                    <td>2</td>
                  </tr>
                  <tr className="odd">
                    <td>MARZO</td>
                    <td>2</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>ABRIL</td>
                    <td>3</td>
                    <td>4</td>
                  </tr>
                  <tr className="odd">
                    <td>MAYO</td>
                    <td>4</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>JUNIO</td>
                    <td>5</td>
                    <td>6</td>
                  </tr>
                  <tr className="odd">
                    <td>JULIO</td>
                    <td>6</td>
                    <td>7</td>
                  </tr>
                  <tr>
                    <td>AGOSTO</td>
                    <td>7</td>
                    <td>8</td>
                  </tr>
                  <tr className="odd">
                    <td>SEPTIEMBRE</td>
                    <td>8</td>
                    <td>9</td>
                  </tr>
                  <tr>
                    <td>OCTUBRE</td>
                    <td>9</td>
                    <td></td>
                  </tr>
                  <tr className="odd">
                    <td>NOVIEMBRE</td>
                    <td>0</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>DICIEMBRE</td>
                    <td>Todos</td>
                    <td></td>
                  </tr>
                </tbody>
              </TableInfo>
              <Buttons className="row">
                <div className="col-xs-12 col-sm-12">
                  <p>Pague la matrícula vehicular</p>
                  <p>
                    <a
                      href="https://www.optar.com.ec/Optar.BPagos.Sri/PagoSriVehiculosAS.aspx"
                      target="_blank"
                      className="btn-impuestos"
                      id="CORPIMP_MATRI_MVPAY"
                    >
                      Pague Aquí
                    </a>
                  </p>
                </div>
              </Buttons>
              <Buttons className="row">
                <div className="col-xs-12 col-sm-12">
                  <p>Consulte valores a pagar::</p>
                  <p>
                    <a
                      href="http://www.amt.gob.ec/index.php/valores-a-pagar.html"
                      target="_blank"
                      className="btn-impuestos"
                      id="CORPIMP_MATRI_VHPAY"
                    >
                      Aquí
                    </a>
                  </p>
                </div>
              </Buttons>
            </div>
          </Container>
        </Content>
      )}
    </Template>
  )
}

export default Matriculacion



// WEBPACK FOOTER //
// ./src/pages/matriculacion.js